import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { BulkHistoryState } from '../models/bulk.models';
import * as selectors from '../selectors/bulk-history.selectors';

@Injectable({ providedIn: 'root' })
export class BulkHistoryFacadeService extends FacadeService {
  constructor(public override store: Store<BulkHistoryState>) {
    super(store);
  }

  // OBSERVABLES
  panelExpanded$ = this.storeSelect(selectors.getPanelExpansion);
  configurationName$ = this.storeSelect(selectors.getConfigurationName);
  statusValues$ = this.storeSelect(selectors.getStatusValues);
  status$ = this.storeSelect(selectors.getStatus);
  importDateFrom$ = this.storeSelect(selectors.getImportDateFrom);
  importDateFromFormat$ = this.storeSelect(selectors.getImportDateFromFormat);
  importDateUntil$ = this.storeSelect(selectors.getImportDateUntil);
  importDateUntilFormat$ = this.storeSelect(selectors.getImportDateUntilFormat);
  importDateFromValidation$ = this.storeSelect(
    selectors.getImportDateFromValidation
  );
  importDateUntilValidation$ = this.storeSelect(
    selectors.getImportDateUntilValidation
  );

  // OBSERVABLE'S VALUES
  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get configurationName() {
    return this.storeSnapshot(this.configurationName$);
  }

  get status() {
    return this.storeSnapshot(this.status$);
  }

  get importDateFrom() {
    return this.storeSnapshot(this.importDateFrom$);
  }

  get importDateUntil() {
    return this.storeSnapshot(this.importDateUntil$);
  }

  get importDateFromFormat() {
    return this.storeSnapshot(this.importDateFromFormat$);
  }

  get importDateUntilFormat() {
    return this.storeSnapshot(this.importDateUntilFormat$);
  }
}
